import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

interface DialogMemoCautionProps {
  open: boolean;
  onClose: () => void;
  patientid: number;
  iconId: number;
  textMemo: string;
  handleSave: (data: any) => void;
}

const DialogMemoCaution: React.FC<DialogMemoCautionProps> = (props) => {
  const [textMemo, setTextMemo] = useState('');

  useEffect(() => {
    setTextMemo(props.textMemo);
  }, [props.textMemo]);

  const handleClose = () => {
    props.onClose();
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setTextMemo(event.target.value);
  };

  const handleSave = () => {
    try {
      const token = getToken();
      postAPI(`/patient/set-caution-note?token=${token}`, {
        caution_note: textMemo,
        patient_id: props.patientid,
        icon_id: props.iconId
      }).then((res) => {
        if (res.code === 200) {
          props.handleSave(res.data)
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      sx={{
        zIndex: 2147483648,
        '& .MuiDialog-paper': {
          width: '400px',
          m: '0px',
        },
      }}
    >
      <DialogContent sx={{p: '16px'}}>
        <TextField
          autoFocus
          // margin='dense'
          id='text-alert'
          fullWidth
          multiline
          rows={4}
          // variant='standard'
          value={textMemo}
          onChange={(event) => handleChange(event)}
          sx={{'& .MuiOutlinedInput-notchedOutline': {borderColor: '#F3F3F3'}}}
        />
      </DialogContent>
      <DialogActions sx={{p: '16px', pt: '0px'}}>
        <BtnOutlineGradient handleButtonClick={handleClose} text='キャンセル' />
        <BtnGradient handleButtonClick={handleSave} text='更新' />
      </DialogActions>
    </Dialog>
  );
};

export default DialogMemoCaution;
